import React, { Component, Fragment } from "react";
import { debounce, cloneDeep } from "lodash";
import {
  Avatar,
  Button,
  Col,
  Form, Input,
  InputNumber,
  List, message,
  Modal,
  Row,
  Select,
  Table, Tabs,
  Tooltip, Spin
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { PriceFormat, SearchFormat } from "../scripts/helpers";
import { Constants } from "../scripts/settings";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import Rules from "../scripts/rules";

class suspendOrderForm extends Component {
  constructor() {
    super();

    this.state = {
      couriers: [],
      data: {
        offerCart: 0,
        payableCart: 0,
        products: [],
        total: 0,
        transferringCost: 0,
      },
      products: [],
      user: { address: [] },
      deleted_barcodes: [],
      userName: "",
      cartId: "",
      loading: false
    };

    this.formRef = React.createRef();
    this.boxRef = React.createRef();
    this.inputRef = React.createRef();
    this.addTypingBarcodeRef = React.createRef();

    // this.handleSearch = debounce(this.handleSearch, 500);
  }

  handleFilter = (input, option) => {
    console.log("handleFilter", input)
    const value = SearchFormat(input);
    const split = value.split(" ");
    let valid = option.code.indexOf(value) >= 0;

    split.forEach((val) => {
      valid = valid || option.name.indexOf(val) >= 0;
    });

    return valid;
  };

  handleCount = (value, record) => {
    const products = [...this.state.data.products];
    const index = products.findIndex((o) => o.id === record.id);
    const product = products[index];
    product.count = value;

    // products.splice(index, 1, product);
    products.unshift(products.splice(index, 1)[0]);


    this.setState({ data: { ...this.state.data, ...{ products: products } } });
  };

  handleSelect_old = (value, clear) => {
    if (value) {
      const { data } = this.state;
      const product = data.products.find((o) => o.id === value);

      if (product) {
        this.handleCount(product.count + 1, product);
      } else {
        const product = this.state.products.find((o) => o.id === value);
        this.setState({
          data: { ...data, ...{ products: [...data.products, product] } },
        });
      }

      if (clear) {
        this.setState({ products: [] });
        this.boxRef.current.resetFields();
        this.inputRef.current.focus();
      }
    } else {
      this.setState({ products: [] });
    }
  };

  handleSelect = (value, clear) => {
    console.log("handleSelect", value)
    setTimeout(() => {
      if (value) {
        const { data } = this.state;
        const ValArr = value.split("_");
        value = parseInt(ValArr[0]);
        const product = data.products.find((o) => o.id === value);
        if (product) {
          this.handleCount(parseInt(product.count) + parseInt(ValArr[1]), product);
        } else {
          const product = this.state.products.find((o) => o.id === value);
          this.setState({
            data: { ...data, ...{ products: [product, ...data.products] } },
          });
        }

        if (clear) {
          console.log("clear")
          // this.setState({ products: [] });
          // this.searchBoxRef.current.resetFields();
          // this.searchInputRef.current.focus();
        }

        let audio = new Audio("/beep-success.mp3")
        audio.play()

      } else {
        this.setState({ products: [] });
      }
    }, 0);
  };

  handleRemove = async (id) => {
    // const products = [...this.state.data.products];
    // this.setState({
    //   data: {
    //     ...this.state.data,
    //     ...{ products: products.filter((o) => o.id !== id) },
    //   },
    // });

    console.log("handleRemove", id)
    console.log(this.state.deleted_barcodes)

    const params = {
      // barcodes:this.state.deleted_barcodes,
      id:id,
      cartId: this.state.cartId
    }


    Modal.confirm({
      title: Resources.confirmDelete,
      okText: Resources.yes,
      okType: 'danger',
      cancelText: Resources.no,
      onOk: () => {
        this.setState({submitting : true});
        API.voip.deleteBarcodes( params)
            .then( (result) => {
              const products = [...this.state.data.products];
              this.setState({
                data: {
                  ...this.state.data,
                  ...{ products: products.filter((o) => o.id !== id) },
                },
              });
              this.setState({deleted_barcodes: this.state.deleted_barcodes.filter(item => item.id !== id )});
              this.setState({submitting : false});
              // const products = [...this.state.formData.products];
              // this.setState({
              //   formData: {
              //     ...this.state.formData,
              //     ...{ products: products.filter((o) => o.id !== id) },
              //   },
              // });


            })
            .catch(() => {
              this.setState({ submitting: false });
            });
      }
    });



  };

  handleSearch = (value) => {


    console.log("handleSearch", value)
    if (value){
      // this.setState({ listLoader: true });
      // this.handleSearchTimeOut(value)
      if(this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        console.log("into timerrrrrrrrr", value)
        //search function
        this.handleSearchTimeOut(value)
      }, 500);
    }
  };

  handleSearchTimeOut = (value) => {
    console.log("handleSearchTimeOut", value);
    this.setState({ loading: true });

    if (value) {
      API.voip
          .products({ q: SearchFormat(value), cart_id: this.state.cartId })
          .then(async (result) => {
            // this.setState({ submitting: false });
            if (result.data && result.data.length) {
              // this.searchInputRef.current.focus();
              await this.getSpecificOrder(this.state.cartId)
              let audio = new Audio("/beep-success.mp3")
              audio.play()
             
            } else {
              this.setState({listLoader: false})
              let audio = new Audio("/beep-warning.mp3")
              audio.play()
              // this.setState({ products: [] });
            }
          })
          .catch(() => {
            this.setState({ submitting: false, listLoader: false });
            let audio = new Audio("/beep-warning.mp3")
            audio.play()
            this.setState({ submitting: false });
          });
    }else{
      this.setState({ submitting: false });
      let audio = new Audio("/beep-warning.mp3")
      audio.play()
      this.setState({ products: [] });
    }
    this.setState({ submitting: false});


  };



  handleOffer = (value) => {
    this.setState({ data: { ...this.state.data, ...{ offerCart: value } } });
  };

  handleTransfer = (value) => {
    this.setState({
      data: { ...this.state.data, ...{ transferringCost: value } },
    });
  };

  handleSubmit_old = () => {
    this.formRef.current.validateFields().then((values) => {
      const cloneData = cloneDeep({ ...this.state.data, ...values });
      const address = this.state.user.address.find(
        (o) => o.id === cloneData.addressId
      );

      // cloneData.lat = address.lat;
      // cloneData.lng = address.lng;
      // cloneData.address = address.address;
      cloneData.barcodes= this.state.deleted_barcodes;

      cloneData.products = cloneData.products.map((o) => {
        const price = o.priceOne ;
        // const discount = o.priceTwo ? (o.priceOne - o.priceTwo) * o.count : 0;
        const discount =  0;

        return {
          product_id: o.id,
          count: o.count,
          price: price,
          payable: price - discount,
          offer: discount,
        };
      });

      this.props.onSubmit(cloneData);
    });
  };

   handleSubmit = async (params = {}) => {
  
      this.setState({ loading: true });
  
      await API.order
          .sendToAccounting(this.state.cartId)
          .then((result) => {
            if (result.status) {
              window.location.reload();
            } else {
              this.setState({ submitting: false });
            }
          })
          .catch(() => {
            this.setState({ submitting: false });
          });
  };
  handleWillUnmount = () => {
    // this.formRef.current.resetFields();
    this.boxRef.current.resetFields();

    this.setState({
      data: {
        offerCart: 0,
        payableCart: 0,
        products: [],
        total: 0,
        transferringCost: 0,
      },
      products: [],
      user: { address: [] },
    });
  };

  handleDidMount = async (data = {}) => {
    this.setState({deleted_barcodes: []})
    this.setState({userName: data.user.name + " "+ data.user.family})
    console.log("cartId:",  data.id)
    this.setState({cartId: data.id})
    await this.getSpecificOrder(data.id)


  };

  getSpecificOrder = async (cartId = {}) => {
  
      this.setState({ loading: true });
  
      await API.order
          .getOrder(cartId)
          .then((result) => {
            if (result.data) {
              this.setState({
                submitting: false,
                listLoader: false,
                selected: result.data,
              });
               let products = result.data.product.map((o) => {
                return {
                  id: o.id,
                  name: o.name,
                  image: o.gallery && o.gallery.length ? o.gallery[0].image : null,
                  inventory: o.barcode_count,
                  code: o.code,
                  priceOne: o.priceOne,
                  priceTwo: o.priceTwo,
                  count: o.pivot.count,
                };
              });

              
              this.setState(prevState => ({
                data: {
                  ...prevState.data,
                  products: products,
                },
              }));
            } else {
              this.setState({ submitting: false, listLoader: false });
            }
          })
          .catch(() => {
            this.setState({ submitting: false, listLoader: false });
          });
  };

  componentDidMount() {
    API.user.list({ level: ["postman"] }).then((result) => {
      this.setState({ couriers: result.data || [] });
    });
  }
  addTypingBarcode = (value) => {
    console.log("ggg", value)
    this.handleSearchTimeOut(value.typing_barcode)
  }

  render() {
    const { onCancel, submitting, visible } = this.props;
    const { couriers, data, products, user, listLoader} = this.state;

    const columns = [
      {
        title: '#',
        key: 'index',
        // width: "20px",
        render: (text: string, record: any, index: number) => index + 1 ,
      },
      {
        title: Resources.title,
        dataIndex: "name",
      },
      {
        title: Resources.image,
        dataIndex: "image",
        width: "50px",
        render: (val) => (
          <Tooltip
            title={
              <Avatar
                src={`${Constants.imagePathProduct}${val}`}
                shape="square"
                size={200}
              />
            }
          >
            <Avatar
              src={`${Constants.imagePathProduct}${val}`}
              shape="square"
              size="small"
            />
          </Tooltip>
        ),
      },
      {
        title: Resources.barcode,
        dataIndex: "code",
        className: "col-center",
        width: "150px",
      },
      {
        title: Resources.inventory,
        dataIndex: "inventory",
        className: "col-center",
        width: "90px",
        render: (val) => val || 0,
      },
      {
        title: Resources.count,
        dataIndex: "count",
        className: "col-center",
        width: "100px",
        render: (val, record) => (
          <InputNumber
            min={1}
            value={val}
            onChange={(value) => this.handleCount(value, record)}
            style={{ width: "100%" }}
            size="large"
          />
        ),
      },
      {
        title: `${Resources.price} (${Resources.rial})`,
        dataIndex: "priceOne",
        className: "col-center",
        width: "120px",
        render: (val) => PriceFormat(val),
      },
      {
        title: Resources.discount,
        dataIndex: "priceTwo",
        className: "col-center",
        width: "100px",
        render: (val, record) => (val ? PriceFormat(record.priceOne - record.priceOne) : 0),
      },
      {
        title: `${Resources.price} (${Resources.rial})`,
        dataIndex: "sum",
        className: "col-center",
        width: "120px",
        render: (val, record) =>
          PriceFormat(
            // record.priceOne  * record.count
            (parseInt(record.priceTwo) ? parseInt(record.priceTwo) : parseInt(record.priceOne)) * parseInt(record.count)
          ),
      },
      {
        title: Resources.action,
        dataIndex: "id",
        className: "col-center",
        width: "80px",
        render: (val) => (
          <Tooltip title={Resources.delete}>
            <Button
              type="link"
              icon={<DeleteOutlined />}
              onClick={() => this.handleRemove(val)}
            />
          </Tooltip>
        ),
      },
    ];

    data.total = 0;

    console.log("data", data.products)
    data.products.forEach((o) => {
      data.total += (parseFloat(o.priceTwo) || parseFloat(o.priceOne)) * parseInt(o.count);
    });

    data.payableCart = data.total;

    return (
      <Fragment>
        <Modal
          title={Resources.editFactor +" : "+this.state.userName}
          visible={visible}
          onOk={this.handleSubmit}
          onCancel={onCancel}
          okText={Resources.sendToAccounting}
          cancelText={Resources.cancel}
          okButtonProps={{ loading: submitting }}
          cancelButtonProps={{ disabled: submitting }}
          width={1000}
          maskClosable={false}
        >
          {listLoader ? (
            <div style={{ textAlign: "center", padding: 50 }}>
              <Spin size="large" />
            </div>
          ) : (

            <>
              <Form ref={this.addTypingBarcodeRef} onFinish={this.addTypingBarcode}>
                <Row gutter={24}>
                  <Col xs={24} sm={10} md={8}>
                    <Form.Item name="typing_barcode" rules={Rules.required}>
                      <Input
                          type="text"
                          size="large"
                          placeholder={Resources.barcode}
                          allowClear
                      />
                    </Form.Item>
                  </Col>
                  <Col
                      xs={24}
                      sm={{ span: 6, offset: 8 }}
                      md={{ span: 4, offset: 12 }}
                  >
                    <Form.Item>
                      <Button
                          type="primary"
                          size="large"
                          htmlType="submit"
                          loading={submitting}
                          block
                      >
                        {Resources.addTypingBarcode}
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>

              <Form ref={this.boxRef}>
                <Form.Item name="search">
                  <Select
                    allowClear
                    filterOption={(input, option) =>
                      this.handleFilter(input, option)
                    }
                    onSearch={this.handleSearch}
                    // onChange={(val) => this.handleSelect(val, false)}
                    placeholder={Resources.search}
                    ref={this.inputRef}
                    className="ant-select-xl"
                    showSearch
                  >
                    {products.map((o) => (
                      <Select.Option
                        key={o.id}
                        // value={o.id}
                        value={o.id+"_"+o.count}
                        name={o.name}
                        // code={o.code}
                        code={o.code + " " + o.value}
                      >
                        {o.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Form>
              <Table
                columns={columns}
                dataSource={data.products}
                pagination={false}
                size="small"
                rowKey="id"
                scroll={{ x: 952 }}
              />
              <Row>
                <span> {(data.products && data.products.length) ? data.products.length : ""}</span>
              </Row>
              <List
                size="small"
                style={{ backgroundColor: "#fafafa", marginBottom: 8 }}
              >
                <List.Item>
                  <List.Item.Meta
                    title={`${Resources.sum} ${Resources.factor} (${Resources.rial})`}
                    style={{ marginRight: 8 }}
                  />
                  <span style={{ width: 120, marginLeft: 80, textAlign: "center" }}>
                    {PriceFormat(data.total)}
                  </span>
                </List.Item>
            
                <List.Item>
                  <List.Item.Meta
                    title={`${Resources.finalPrice} (${Resources.rial})`}
                    style={{ marginRight: 8 }}
                  />
                  <span style={{ width: 120, marginLeft: 80, textAlign: "center" }}>
                    {PriceFormat(data.payableCart)}
                  </span>
                </List.Item>
              </List>
              
            


            </>
          )}

        </Modal>
      </Fragment>
    );
  }
}

export default suspendOrderForm;
